module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "center"
  }, [_c('p', {
    staticClass: "ORIM-Dedication--Front-Matter-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("To Suzy, Bob, Colleen, and Bonnie, for all the love and support you have shown me over the years")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3025b596","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MissingHeiress1.vue
// module id = 75
// module chunks = 0